export default __webpack_public_path__ + "static/media/Metropolis-LightItalic.7aa2b6e1.otf";